import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {EventTriggerSearchModel} from "../event-trigger-search.model";
import {EventTriggerEntityModel} from "../event-trigger-entity.model";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-event-trigger-search-page",
    templateUrl: "./event-trigger-search-page.component.html",
    providers: [provideSearchModel(EventTriggerSearchModel), provideEntityModel(EventTriggerEntityModel) ]
})
export class EventTriggerSearchPageComponent extends AbstractSearchPage {
    constructor() {
        super();
    }
}
